<div class="toast-stack" role="region" aria-live="polite">
  <div
    *ngFor="let t of toastService.toasts(); trackBy: trackById"
    class="toast-card"
    [class.toast-success]="t.type === 'success'"
    [class.toast-error]="t.type === 'error'"
    [class.toast-info]="t.type === 'info'"
  >
    <span class="toast-icon">
      <fa-icon [icon]="iconFor(t)"></fa-icon>
    </span>
    <div class="toast-body">
      <p class="toast-title">{{ t.title }}</p>
      <p *ngIf="t.message" class="toast-msg">{{ t.message }}</p>
    </div>
    <button type="button" class="toast-close" (click)="close(t.id)" aria-label="Cerrar">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
    <span class="toast-bar"></span>
  </div>
</div>
